"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSubCategoryOrLookBookLink = exports.isNotCategoryLink = exports.getWhatsNewAndAllCategory = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
const isSubCategoryOrLookBookLink = linkType => linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.SubCategory || linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.PopularLookbook;
exports.isSubCategoryOrLookBookLink = isSubCategoryOrLookBookLink;
const isNotCategoryLink = linkType => [_staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.WhatsNewInCategory, _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.SubCategory, _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.AllCategory, _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.PopularLookbook].every(type => linkType !== type);

/**
 * Get the what's new and all category links which are randomly ordered and return what's new first
 * @param subCategories
 */
exports.isNotCategoryLink = isNotCategoryLink;
const getWhatsNewAndAllCategory = subCategories => {
  const whatsNewCategory = subCategories.find(({
    linkType
  }) => linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.WhatsNewInCategory);
  const otherCategories = subCategories.filter(({
    linkType,
    url
  }) => linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.AllCategory && url);
  return whatsNewCategory ? [whatsNewCategory, ...otherCategories] : otherCategories;
};
exports.getWhatsNewAndAllCategory = getWhatsNewAndAllCategory;
//# sourceMappingURL=utils.js.map